import styled from "@emotion/styled"
import { convertTimetoString } from "../../../../helperFunction";
interface PaymentDurationDetails {
    Id: number;
    PaymentType: string;
    StartDate: string;
    EndDate: string;
    IsActive: boolean;
  }


interface PaymentDurationProps {
    data?: PaymentDurationDetails
}


const PaymentDuration = ({data}: PaymentDurationProps) => {

    return(
        <Container>
            <h3>Details</h3>
            <div>
                <span>Status</span>
                <div style={{background:  data?.IsActive === false ? '#DD5151' : ''}}>{data?.IsActive ? 'Active' : 'Disabled'}</div>
            </div>
            <div>
                <span>Start Date</span>
                <span>{convertTimetoString(data?.StartDate, 0) }</span>
            </div>
            <div>
                <span>End Date</span>
                <span>{convertTimetoString(data?.EndDate, 0) }</span>
            </div>
            <div>
                <span>Action</span>
                <span>{data?.PaymentType}</span>
            </div>
        </Container>
    )
}

export default PaymentDuration;


const Container = styled('div')`
    padding: 40px;

    & > h3 {
        padding-block-end: 20px !important;     
        margin-block: 0px;
        font-weight: 500;
        font-size: 24px;
        line-height: 24px;
        color: #020D08;
    }

    & > div {
        padding-block: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        & > span {
            font-weight: 400;
            font-size: 24px;
            line-height: 24px;
            color: #020D08;
        }

        & > span:nth-child(1) {
            color: #4E5A62;
        }

        & > div {
            background: #E0FAEE;
            border-radius: 4px;
            padding-inline: 22px;
            padding-block: 8px;
            color: #11643C;

        }
    }
`